// import {useState} from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./calendar.css"; // custom styling

const CalendarWithEvents = ({events = [], handleChangeMonth = () => {}, selectedDate, onChangeDate = () => {}}) => {
	// const [selectedDate, setSelectedDate] = useState(new Date());
	// const [newEventTitle, setNewEventTitle] = useState("");

	const handleDateChange = date => {
		const event = events
			.filter(item => item.times?.length)
			.find(item => {
				return isSameDay(new Date(item.date), date);
			});

		onChangeDate(date, event);
	};

	const isSameDay = (d1, d2) => {
		return (
			d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2?.getDate()
		);
	};

	const tileClassName = ({date, view}) => {
		if (view === "month") {
			const hasEvent = events
				.filter(item => item.times?.length)
				?.map(item => item.date)
				.some(event => isSameDay(new Date(event), date));

			return hasEvent && !isSameDay(date, selectedDate) ? "has-event" : null;
		}
	};

	const handleMonthChange = ({activeStartDate, view}) => {
		if (view === "month") {
			const year = activeStartDate.getFullYear();
			const month = activeStartDate.getMonth();

			handleChangeMonth(month, year);
		}
	};

	return (
		<div className="calendar-container">
			<Calendar
				minDate={new Date()}
				tileClassName={tileClassName}
				value={selectedDate}
				onActiveStartDateChange={handleMonthChange}
				onChange={handleDateChange}
			/>
		</div>
	);
};

export default CalendarWithEvents;
